import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function withdrawalManagerList(data) { return axios.post(`${base.url}/payment/withdrawalManager/list`, qs.stringify(data)) }
export function withdrawalManagerStats(data) { return axios.post(`${base.url}/payment/withdrawalManager/stats`, qs.stringify(data)) }
export function withdrawalManagerReviewStatusCounts(data) { return axios.post(`${base.url}/payment/withdrawalManager/reviewStatusCounts`, qs.stringify(data)) }
// remark=审核备注（通过=审核意见；拒绝=「拒绝原因 + 审核意见」合成一条），后端落库到订单 remark 列，
// 在详情弹窗的「审核结果」里回显
export function withdrawalManagerBatchReview(ids, reviewStatus, remark) { return axios.post(`${base.url}/payment/withdrawalManager/batchReview`, qs.stringify({ ids, reviewStatus, remark })) }
export function withdrawalManagerExport(data) { return axios.post(`${base.url}/payment/withdrawalManager/export`, qs.stringify(data), { responseType: 'blob' }) }
